import css from "standard/css";

const style = css`
  .installPWA {
    align-items: center;
    background-color: var(--color-master-lightest);
    border: var(--border-width-thin) solid var(--color-primary);
    border-radius: var(--border-radius-sm);
    color: var(--color-primary);
    content-visibility: auto;
    cursor: pointer;
    display: flex;
    font-family: var(--font-family-base);
    font-size: var(--font-size-xxs);
    font-weight: var(--font-weight-medium);
    gap: var(--spacing_inset-nano);
    height: 42px;
    padding: 0 var(--spacing_inset-xs);

    svg {
      height: 24px;
      width: 24px;
    }

    span {
      display: none;
    }
  }

  @media (width >= 768px) {
    .installPWA {
      span {
        display: inline;
      }
    }
  }
`;

export default style;
